//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The MICR Status */
export const MICRStatus = {
    /** Success means the scanned MICR contains no invalid read chars ('!' for Canon and '?' for Magtek) */
    Success: 0,

    /**
     * Fail means the scanned MICR contains at least one invalid read char ('!' for Canon and '?' for Magtek)
     * but the user chose to Upload it anyway
     */
    Fail: 1
} as const;

/** The MICR Status */
export const MICRStatusDescription: Record<number, string> = {
    0: "Success",

    1: "Fail"
};

/** The MICR Status */
export type MICRStatus = typeof MICRStatus[keyof typeof MICRStatus];
